export const environment = {
  production: false,
  ApiKeyGoogleMaps: 'AIzaSyCHjX6xr4eBMjKNjj9Eu0WcYD3mW_Ee68o',  
  // Wompi
  //ApiPublicKeyWompi: 'pub_test_WfXURaN3EFia79nWb4tQMzXDlkYl8uQB',  // GUIA developer COPIA Y PEGAR ***
  ApiPublicKeyWompi: 'pub_prod_QqZ11XeRwx9fNnI6hVkGeRMovXlAAZDd',
  // ApiPrivateKeyWompi: 'pub_prod_QqZ11XeRwx9fNnI6hVkGeRMovXlAAZDd' // GUIA produccion COPIA Y PEGAR ***
};
